/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

angular.module('aviApp').directive('sideColumnCollapseButton', ['myAccount', function(myAccount) {
    function sideColumnCollapseButtonLink(scope, element) {
        element
            .addClass('button-side-column')
            .on('click', () => myAccount.toggleSidebar());

        scope.$watch(
            () => myAccount.sideRailOpen,
            newValue => element.toggleClass('collapsed', !newValue),
        );
    }

    return {
        scope: false,
        link: sideColumnCollapseButtonLink,
        template: '<i class="icon icon-cancel-1"></i><i class="icon icon-chevron-left"></i>',
    };
}]);
